import { Trophy } from 'lucide-react';
import { cn } from '../../lib/utils';

// Gold / silver / bronze for the first three ranks; nothing for the rest.
const TROPHY_COLORS: Record<number, string> = {
  1: 'text-yellow-500',
  2: 'text-slate-400',
  3: 'text-amber-700',
};

interface RankTrophyProps {
  rank: number;
  className?: string;
}

export function RankTrophy({ rank, className }: RankTrophyProps) {
  const color = TROPHY_COLORS[rank];
  if (!color) return null;
  return <Trophy className={cn(color, className)} aria-hidden="true" />;
}
